var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.27 29.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d2a784;}.cls-2{fill:#1c2c58;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "facebook") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.27,14.64A14.64,14.64,0,1,0,12.35,29.1V18.87H8.63V14.64h3.72V11.41c0-3.67,2.19-5.69,5.53-5.69A23.07,23.07,0,0,1,21.16,6V9.61H19.31a2.11,2.11,0,0,0-2.39,2.28v2.75H21l-.64,4.23H16.92V29.1A14.65,14.65,0,0,0,29.27,14.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.34,18.87,21,14.64H16.92V11.89a2.11,2.11,0,0,1,2.39-2.28h1.85V6a23.07,23.07,0,0,0-3.28-.28c-3.34,0-5.53,2-5.53,5.69v3.23H8.63v4.23h3.72V29.1a15.72,15.72,0,0,0,2.29.17,15.48,15.48,0,0,0,2.28-.17V18.87Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.610d40e1e0a73e9ccc548ec11d474428.svg";
export { ForwardRef as ReactComponent };